import { SalesTaxFiling } from '@commenda/api';
import { ServiceRequestStatus, TaskStatus } from '@commenda/prisma';
import { SalesTaxFilingTasks } from '@commenda/types/src/sales-tax/types';
import { Filing } from '../../../molecules';
import { FilingReviewStatus } from '../../../molecules/filings/types';

export const isFilingApproved = (filing: Filing<SalesTaxFiling>): boolean => {
  if (!filing.serviceRequest?.taskGroups) {
    return false;
  }

  const reviewTask = filing.serviceRequest.taskGroups
    .flatMap((taskGroup) => taskGroup.tasks)
    .find(
      (task) =>
        task.legacyServiceRequestTaskTaskId ===
        SalesTaxFilingTasks.REVIEW_TRANSACTIONS
    );

  return reviewTask?.status === TaskStatus.COMPLETED;
};

export const isFilingOverdue = (filing: Filing<SalesTaxFiling>): boolean => {
  if (!filing.serviceRequest?.taskGroups) {
    return false;
  }

  const reviewTask = filing.serviceRequest.taskGroups
    .flatMap((taskGroup) => taskGroup.tasks)
    .find(
      (task) =>
        task.legacyServiceRequestTaskTaskId ===
        SalesTaxFilingTasks.REVIEW_TRANSACTIONS
    );

  // Legacy DISABLED ("review closed because overdue") maps to BACKLOG.
  return reviewTask?.status === TaskStatus.BACKLOG;
};

export const hasReviewTask = (filing: Filing<SalesTaxFiling>): boolean => {
  if (!filing.serviceRequest?.taskGroups) {
    return false;
  }

  const reviewTask = filing.serviceRequest.taskGroups
    .flatMap((taskGroup) => taskGroup.tasks)
    .find(
      (task) =>
        task.legacyServiceRequestTaskTaskId ===
        SalesTaxFilingTasks.REVIEW_TRANSACTIONS
    );

  return !!reviewTask;
};

export const canUnlockFiling = (filing: Filing<SalesTaxFiling>): boolean => {
  if (!filing.id) return false;
  if (filing.filingStatus !== FilingReviewStatus.FILED) return false;
  if (filing.serviceRequest?.status !== ServiceRequestStatus.COMPLETED) return false;
  return true;
};

export const canApproveFiling = (filing: Filing<SalesTaxFiling>): boolean => {
  if (!filing.id) {
    return false;
  }

  // Must have a review task to be approvable
  if (!hasReviewTask(filing)) {
    return false;
  }

  if (isFilingApproved(filing)) {
    return false;
  }

  if (isFilingOverdue(filing)) {
    return false;
  }

  return true;
};
